import { Component, ErrorInfo, ReactNode } from 'react';

import { VpnReminderPage } from 'features/vpnReminderPage';

import SomethingWentWrongPage from '../somethingWentWrongPage/somethingWentWrongPage';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
  canReadVersion: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    canReadVersion: true,
  };

  public static getDerivedStateFromError(): Partial<State> {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    this.setState((prev) => ({ ...prev, error, errorInfo }));

    fetch('/version.txt', {
      method: 'GET',
      headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache', Expires: '0' },
    })
      .then(() => this.setState((prev) => ({ ...prev, canReadVersion: true })))
      .catch(() => this.setState((prev) => ({ ...prev, canReadVersion: false })));
  }

  public render(): ReactNode {
    console.info(this.state);

    if (!this.state.canReadVersion && !this.state.hasError) {
      return <VpnReminderPage />;
    }

    if (this.state.hasError) {
      return <SomethingWentWrongPage error={this.state.error} />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
